'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBox = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _SearchBox = require('./SearchBox.constants');

var _LocationFieldContainer = require('./LocationFieldContainer');

var _KeywordFieldContainer = require('./KeywordFieldContainer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBox = exports.SearchBox = function SearchBox(_ref) {
  var openPanel = _ref.openPanel,
      onPanelClose = _ref.onPanelClose,
      mediaQueryLg = _ref.mediaQueryLg,
      onToggleMapView = _ref.onToggleMapView;

  var panelOpenOnMobile = !!openPanel && !mediaQueryLg;
  var locationOpen = openPanel === _SearchBox.PANEL_NAMES.location;
  var keywordOpen = openPanel === _SearchBox.PANEL_NAMES.keyword;
  var locationOpenOnMobile = panelOpenOnMobile && locationOpen;
  var keywordOpenOnMobile = panelOpenOnMobile && keywordOpen;
  var closedOrLocationOpenOnMobile = !openPanel || mediaQueryLg || locationOpenOnMobile;
  var closedOrKeywordOpenOnMobile = !openPanel || mediaQueryLg || keywordOpenOnMobile;
  var mapIcon = require('../../../../static/img/icon/mapview.svg');

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('searchbox', {
        'searchbox--panel-open': !!panelOpenOnMobile
      })
    },
    _react2.default.createElement(
      'div',
      { className: 'searchbox__inputs' },
      panelOpenOnMobile && _react2.default.createElement(
        'div',
        {
          className: 'searchbox__close',
          onClick: onPanelClose
        },
        _react2.default.createElement(_reactInlinesvg2.default, { src: require('../../../../static/img/icon/back.svg') })
      ),
      closedOrKeywordOpenOnMobile && _react2.default.createElement(_KeywordFieldContainer.KeywordFieldContainer, {
        isOpen: keywordOpen,
        isOpenPanelOnMobile: keywordOpenOnMobile
      }),
      closedOrLocationOpenOnMobile && _react2.default.createElement(_LocationFieldContainer.LocationFieldContainer, {
        isOpen: locationOpen,
        isOpenPanelOnMobile: locationOpenOnMobile
      }),
      !openPanel && _react2.default.createElement(
        'div',
        {
          className: 'searchbox__map',
          onClick: onToggleMapView
        },
        _react2.default.createElement(_reactInlinesvg2.default, { src: mapIcon })
      )
    )
  );
};

SearchBox.propTypes = {
  openPanel: _propTypes2.default.string,
  onPanelClose: _propTypes2.default.func.isRequired,
  onToggleMapView: _propTypes2.default.func.isRequired,
  mediaQueryLg: _propTypes2.default.bool
};